/* eslint-disable react/jsx-props-no-spreading */
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import useTanQuery from '../../hooks/useTanQuery';

import { useApi } from '../../contexts/ApiContext';
import Select from './SmartSelect';

const propTypes = {
    resource: PropTypes.string,
    valuePath: PropTypes.string,
    labelPath: PropTypes.string,
    query: PropTypes.shape({}),
    options: PropTypes.arrayOf(PropTypes.shape({})),
};

const SelectField = ({
    resource = null,
    valuePath = 'id',
    labelPath = 'title',
    query: initialQuery = null,
    options: initialOptions = [],
    ...props
}) => {
    const api = useApi();

    const [resourceOptions, setResourceOptions] = useState(null);

    const callback = useCallback(
        (query) => {
            if (api !== null && typeof api[resource] !== 'undefined') {
                return api[resource].get(query);
            }
            return new Promise();
        },
        [api, resource],
    );

    const { data } = useTanQuery(resource, callback, { query: initialQuery });

    useEffect(() => {
        if (data !== null && data.length > 0) {
            setResourceOptions(
                (data || []).map((item) => ({
                    value: get(item, valuePath) || null,
                    label: get(item, labelPath) || null,
                })),
            );
        }
    }, [data, setResourceOptions]);

    const finalOptions = useMemo(
        () => resourceOptions || initialOptions,
        [resourceOptions, initialOptions],
    );

    return <Select options={finalOptions} {...props} />;
};

SelectField.propTypes = propTypes;

export default SelectField;
